import { gql } from 'graphql-request'

export const MANAGE_SEARCH_KEYWORD = gql`
  mutation ManageSearchKeyword(
    $manageSearchKeywordInput: ManageSearchKeywordInput!
  ) {
    manageSearchKeyword(manageSearchKeywordInput: $manageSearchKeywordInput)
  }
`
